"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationList = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _List = require("./List.js");
var _Nav = require("./Nav.js");
var _excluded = ["flexMobile", "children"];
/**
 * This is a title and list of links used in the Navigation component.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-navigation-navigationlist--docs) |
 * [Encore site](https://encore.spotify.net/web/components/navigation) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/NavigationList) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=885-417&t=rDdNHhld76Wp0C3r-1)
 */
var NavigationList = exports.NavigationList = function NavigationList(_ref) {
  var _ref$flexMobile = _ref.flexMobile,
    flexMobile = _ref$flexMobile === void 0 ? true : _ref$flexMobile,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Nav.Nav, Object.assign({}, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.NavigationList
  }), /*#__PURE__*/_react["default"].createElement(_List.List, {
    $flex: flexMobile
  }, children));
};